export const VERSION = "3.6.1";
